
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DisplayLoggerComparison"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"displayLoggerComparison"},"name":{"kind":"Name","value":"displayLoggerAttributes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"backlight"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"displayModes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"supportsDisplayCreator"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dataLoggingMemory"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"loggingRate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"i2StandardAnalysis"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"i2ProAnalysis"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"t2Telemetry"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"analogueVoltage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"analogueTemperature"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"digital"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"speed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"switch"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"widebandLambda"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"expansionUnits"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"digSwitchPwm"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"outExpansionUnits"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"can"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rs232"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rs422rs485"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ethernet"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":516}};
    doc.loc.source = {"body":"query DisplayLoggerComparison {\n  displayLoggerComparison: displayLoggerAttributes {\n    documentId\n    type\n    backlight\n    displayModes\n    supportsDisplayCreator\n    dataLoggingMemory\n    loggingRate\n    i2StandardAnalysis\n    i2ProAnalysis\n    t2Telemetry\n    analogueVoltage\n    analogueTemperature\n    digital\n    speed\n    switch\n    widebandLambda\n    expansionUnits\n    digSwitchPwm\n    outExpansionUnits\n    can\n    rs232\n    rs422rs485\n    ethernet\n    product {\n      documentId\n      name\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["DisplayLoggerComparison"] = oneQuery(doc, "DisplayLoggerComparison");
        
